import { useState, FormEvent } from 'react';

import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import { LoadingOutlined } from '@ant-design/icons';

import logoImg from '../../assets/general/logo.svg';
import truckImg from '../../assets/general/truck.svg';
import backgroundImg from '../../assets/general/background.svg';

import { Container, Form, SideTruck, SaveLogin } from './styles';

import { useAuth } from '../../hooks/Auth';

export const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [saveLogin, setSaveLogin] = useState(false);

  const history = useHistory();

  const { signIn } = useAuth();

  const validateFormFields = () => {
    if (!email.trim() || !password.trim()) {
      return false;
    }
    return true;
  };

  async function handleLoginSubmit(
    event: FormEvent<HTMLFormElement>,
  ): Promise<void> {
    event.preventDefault();

    if (!validateFormFields()) {
      toast.error('Digite corretamente seu e-mail e senha');
      return;
    }

    try {
      setLoading(true);

      await signIn({
        email,
        password,
        saveLogin,
      });

      setLoading(false);
      toast.success('Seja bem vindo!');
    } catch (err) {
      setLoading(false);
      handleError(err);
    }
  }

  const handleError = async (error: any) => {
    let message;
    if (error?.response?.data?.message) {
      message = error?.response?.data.message;
    } else {
      message = error?.toString();
    }

    setLoading(false);
    toast.error(message);
  };

  return (
    <Container>
      <aside>
        <div>
          <header>
            <img src={logoImg} alt="Selad" />
          </header>

          <Form onSubmit={handleLoginSubmit}>
            <div>
              <label>Login</label>
              <input
                type="text"
                name="login"
                placeholder="Insira seu Login"
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>

            <div>
              <label>Senha</label>
              <input
                type="password"
                name="password"
                placeholder="Insira sua Senha"
                onChange={(e) => setPassword(e.target.value)}
              />
            </div>

            <div>
              {loading ? (
                <button type="submit">
                  <LoadingOutlined />
                </button>
              ) : (
                <button type="submit">Entrar</button>
              )}
            </div>

            <SaveLogin>
              <label>
                <input
                  type="checkbox"
                  checked={saveLogin}
                  onChange={() => setSaveLogin(!saveLogin)}
                />
                Salvar login
              </label>
              {/* <a href="/">Esqueceu a senha?</a> */}
            </SaveLogin>
          </Form>
        </div>
      </aside>

      <SideTruck
        style={{
          backgroundImage: `url(${backgroundImg})`,
        }}
      >
        <img src={truckImg} alt="Caminhão Selad" />
      </SideTruck>
    </Container>
  );
};
